export default __webpack_public_path__ + "static/media/test6.09bcb1cb.png";